import { useMemo } from "react"

import { teeupStatusKeys } from "@config/enums"
import { getStageOptions } from "@utils/teeupStateUtils"
import { Stage } from "types/teeup"

import Item from "./Item"

import "./index.scss"

interface TimeLineProps {
  currentStage: Stage | null
  changeStatus: (stage: Stage) => void
  isOnlyGeneralWhenSuggestion: boolean
}

const TimeLine = ({
  currentStage,
  changeStatus,
  isOnlyGeneralWhenSuggestion,
}: TimeLineProps) => {
  const stageOptions = useMemo(
    () => getStageOptions().filter(stage => !stage.isHidden),
    []
  )

  // FIX 2026-07-04 (terminal stages don't offer revert, part 2): once the TeeUp is Ended/Cancelled
  // there is no reopen affordance on the mobile gold standard, so the whole timeline renders
  // non-interactive/dimmed rather than looking like a live picker that silently no-ops on click.
  const isTerminal =
    currentStage?.label === teeupStatusKeys.ended ||
    currentStage?.label === teeupStatusKeys.cancelled

  return (
    <div className="time-line">
      {stageOptions.map((stage, index) => (
        <Item
          stage={stage}
          key={index}
          isFirstItem={index === 0}
          isLastItem={index === stageOptions.length - 1}
          currentStage={currentStage}
          isTerminal={isTerminal}
          isHappeningNowDisabled={
            isOnlyGeneralWhenSuggestion &&
            stage.label === teeupStatusKeys.happening
          }
          // FIX 2026-07-04 (toast repair): route the click through changeStatus even when
          // terminal -- its Ended/Cancelled pre-flight guard shows the canonical
          // isAlready*Warning toast (QJ: blocked actions must VISIBLY toast, never a
          // silent no-op). Rows still render dimmed/non-affordant via isTerminal.
          onClick={() => changeStatus(stage)}
        />
      ))}
    </div>
  )
}

export default TimeLine
